import { render, staticRenderFns } from "./PostCard.vue?vue&type=template&id=5438c75c&scoped=true"
import script from "./PostCard.vue?vue&type=script&lang=js"
export * from "./PostCard.vue?vue&type=script&lang=js"
import style0 from "./PostCard.vue?vue&type=style&index=0&id=5438c75c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5438c75c",
  null
  
)

export default component.exports